import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AppShell from './AppShell';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <span className="text-mbc-mute text-sm">verificando sessão…</span>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <AppShell />;
}
